var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('DraggableTiles',{ref:"DraggableTiles",attrs:{"tilesProp":_vm.tiles,"storeModule":_vm.layoutStore,"version":_vm.version}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }